const swiper = () => {
    linkBlockSlider();
    reviewsSlider();
}

const linkBlockSlider = () => {
    const breakpoint = window.matchMedia('(min-width: 768px)');
    // keep track of swiper instances to destroy later
    let mySwiper;

    const breakpointChecker = function () {
        // if larger viewport and multi-row layout needed
        if (breakpoint.matches === true) {
            // clean up old instances and inline styles when available
            if (mySwiper !== undefined) mySwiper.destroy(true, true);
            // or/and do nothing
            return;
            // else if a small viewport and single column layout needed
        } else if (breakpoint.matches === false) {
            // fire small viewport version of swiper
            return enableSwiper();

        }

    };

    const enableSwiper = function () {
        mySwiper = new Swiper('.link-blocks-swiper', {
            loop: false,
            spaceBetween: 20,
            grabCursor: true,
        });
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
}

const reviewsSlider = () => {
    // Get all the sliders with the class name .reviews-slider
    const sliders = document.querySelectorAll('.reviews-slider-section');

    // Check if there are any sliders on the page
    if (sliders.length > 0) {
        // Loop through each slider and initialize Swiper
        sliders.forEach((slider) => {
            let thisSlider = slider.querySelector('.reviews-slider');
            let thisCSwiper = new Swiper(thisSlider, {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 7000,  // Autoplay with a delay of 3 seconds between slides
                },
            });

            let thisSliderNextArrow = slider.querySelector('.swiper-arrows__next');
            let thisSliderPrevArrow = slider.querySelector('.swiper-arrows__prev');

            //Move to next slide if 'next' arrow clicked
            if(thisSliderNextArrow){
                thisSliderNextArrow.addEventListener('click', (event) => {
                    thisCSwiper.slideNext();
                })
            }

            if(thisSliderPrevArrow){
                thisSliderPrevArrow.addEventListener('click', (event) => {
                    thisCSwiper.slidePrev();
                })
            }
        });
    }
}

swiper();